import WeekPage from "./WeekPage";

export default WeekPage;
